// payments stream: the drawer, receipts, remittance.
export const en: Record<string, string> = {
  "nav.payments": "Payments",
  "payments.title": "Payments",
  "payments.subtitle": "What the office took, by whom and how, with a receipt for every one and a check on what still has to be posted to the carrier.",
  "payments.notProcessor": "The agency is not a card processor: cards are taken on its own terminal and recorded here. Ask 10x about online card payments when the agency wants them.",
  "payments.record": "Record a payment",
  "payments.day": "Day",
  "payments.total": "Total",
  "payments.unremitted": "To be remitted",
  "payments.count": "{n} payments",
  "payments.method": "Method",
  "payments.method.cash": "Cash",
  "payments.method.card": "Card",
  "payments.method.check": "Check",
  "payments.method.money_order": "Money order",
  "payments.method.other": "Other",
  "payments.purpose": "Purpose",
  "payments.purpose.premium": "Premium",
  "payments.purpose.down_payment": "Down payment",
  "payments.purpose.installment": "Installment",
  "payments.purpose.reinstatement": "Reinstatement",
  "payments.purpose.fee": "Fee",
  "payments.purpose.other": "Other",
  "payments.amount": "Amount",
  "payments.reference": "Reference (check #, card last four)",
  "payments.note": "Note",
  "payments.receipt": "Receipt",
  "payments.openReceipt": "Open receipt",
  "payments.textReceipt": "Text receipt",
  "payments.receiptTexted": "Receipt texted",
  "payments.takenBy": "Taken by",
  "payments.remitted": "Remitted",
  "payments.pending": "Not yet remitted",
  "payments.void": "Void",
  "payments.voided": "Void",
  "payments.voidReason": "Why is this void?",
  "payments.markRemitted": "Mark remitted",
  "payments.remitRef": "Carrier confirmation / deposit reference",
  "payments.remitDone": "Marked remitted",
  "payments.recorded": "Payment recorded",
  "payments.voidedToast": "Payment voided",
  "payments.none": "No payments on this day.",
  "payments.customerCard": "Payments",
  "payments.selectAll": "Select all pending",
  "payments.policy": "Policy",
  "payments.noPolicy": "No policy",
  "reports.payments": "Payments",
};

export const es: Record<string, string> = {
  "nav.payments": "Pagos",
  "payments.title": "Pagos",
  "payments.subtitle": "Lo que la oficina recibió, quién y cómo, con recibo para cada pago y control de lo que falta por enviar a la aseguradora.",
  "payments.notProcessor": "La agencia no procesa tarjetas: se cobran en su propia terminal y se registran aquí. Pregunte a 10x por pagos con tarjeta en línea cuando la agencia los quiera.",
  "payments.record": "Registrar pago",
  "payments.day": "Día",
  "payments.total": "Total",
  "payments.unremitted": "Por remitir",
  "payments.count": "{n} pagos",
  "payments.method": "Forma de pago",
  "payments.method.cash": "Efectivo",
  "payments.method.card": "Tarjeta",
  "payments.method.check": "Cheque",
  "payments.method.money_order": "Giro postal",
  "payments.method.other": "Otro",
  "payments.purpose": "Concepto",
  "payments.purpose.premium": "Prima",
  "payments.purpose.down_payment": "Enganche",
  "payments.purpose.installment": "Mensualidad",
  "payments.purpose.reinstatement": "Reinstalación",
  "payments.purpose.fee": "Cargo",
  "payments.purpose.other": "Otro",
  "payments.amount": "Monto",
  "payments.reference": "Referencia (# de cheque, últimos 4 de tarjeta)",
  "payments.note": "Nota",
  "payments.receipt": "Recibo",
  "payments.openReceipt": "Abrir recibo",
  "payments.textReceipt": "Enviar recibo por mensaje",
  "payments.receiptTexted": "Recibo enviado",
  "payments.takenBy": "Atendió",
  "payments.remitted": "Remitido",
  "payments.pending": "Sin remitir",
  "payments.void": "Anular",
  "payments.voided": "Anulado",
  "payments.voidReason": "¿Por qué se anula?",
  "payments.markRemitted": "Marcar remitido",
  "payments.remitRef": "Confirmación de la aseguradora / referencia de depósito",
  "payments.remitDone": "Marcado como remitido",
  "payments.recorded": "Pago registrado",
  "payments.voidedToast": "Pago anulado",
  "payments.none": "No hay pagos en este día.",
  "payments.customerCard": "Pagos",
  "payments.selectAll": "Seleccionar pendientes",
  "payments.policy": "Póliza",
  "payments.noPolicy": "Sin póliza",
  "reports.payments": "Pagos",
};
